<template>
    <!-- <div class="backdrop" @click.self="closeModal"> -->
    <div class="backdrop">
        <div class="modal">
            <h1>{{ modalHeader }}</h1>
            <form action="" class="form">
                <div class="form__group">
                <input 
                    type="text" 
                    v-model="title" 
                    placeholder="" 
                    class="form__input" 
                    id="project_title" 
                    :maxlength="getMaxLength('title')"
                    :disabled="this.releaseStatus ==='VALIDATED' || this.releaseStatus ==='ARCHIVED' || this.releaseStatus ==='ARCHIVE' || this.releaseStatus ==='VALIDATION'"
                    />
                <label for="project_title" class="form__label">Nom</label>
                <span class="form__p">({{ title.length }}/{{ getMaxLength('title') }})</span>
                </div>

                <div class="form__group">
                <input 
                    type="text" 
                    v-model="description" 
                    placeholder="" 
                    class="form__input" 
                    id="project_description" 
                    :maxlength="getMaxLength('description')"
                    :disabled="this.releaseStatus ==='VALIDATED' || this.releaseStatus ==='ARCHIVED' || this.releaseStatus ==='ARCHIVE' || this.releaseStatus ==='VALIDATION'"
                />
                <label for="project_description" class="form__label">Description</label>
                <span class="form__p">({{ description.length }}/{{ getMaxLength('description') }})</span>
                </div>
            
                <div v-if="selectedProject === 0 && selectedReferential === 0" class="form-group">
                    <label for="selected_referential" class="field-title">Référentiel</label>
                    <select v-model="referential_id" class="form__select" id="selected_referential">
                        <option v-for="referential in productionReferentials" :key="referential.referentiel_id" :value="referential.referentiel_id">
                            {{ referential.title }}
                        </option>
                    </select>
                </div>
                <div v-else class="form-group">
                    <label for="selected_referential" class="field-title">Référentiel</label>
                    <input type="hidden" v-model="referential_id" id="selected_referential" />
                    <input type="text" :value="getReferentialName()" :disabled="true" class="form__input">
                </div>
               <!--  <div v-if="selectedProject" class="action-buttons">
                    <button v-if="releaseStatus === 'EDITING'" @click.prevent="changeProjectStatus('VALIDATION')" class="create-button">Mise en évaluation</button>
                    <button v-if="releaseStatus === 'VALIDATION' && !isEvaluationView" @click.prevent="changeProjectStatus('EDITING')" class="create-button">Remise en édition</button>
                    <button v-if="releaseStatus === 'VALIDATION' && isEvaluationView" @click.prevent="changeProjectStatus('VALIDATED')" class="create-button">Valider projet</button>
                    <button v-if="releaseStatus === 'VALIDATED'" @click.prevent="changeProjectStatus('ARCHIVE')" class="create-button">Archiver</button>
                </div> -->
                <label for="status" class="form__label"></label>
                <button v-if="this.releaseStatus === 'EDITING'" @click.prevent="submitForm">{{ submitButton }}</button>
                <button @click.prevent="closeModal">Annuler</button>
            </form>
        </div>
    </div>
    <LoadingOverlay v-if="loading"/>
    <!-- <ConfirmationDialog v-if="confirmationDialogOpen" /> -->
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import '../../assets/styles/base.css'
import '../../assets/styles/modal.css'
import LoadingOverlay from '../generic/LoadingOverlay.vue';
// import ConfirmationDialog from '../generic/ConfirmationDialog.vue';

export default {
    name: "ReferentialModalCreator",
    components: {
        LoadingOverlay
        // ConfirmationDialog,
    },
    data() {
        return {
            project_id: 0,
            title: "",
            description: "",
            referential_id: 0,
            releaseStatus: "EDITING",
            modalHeader: "Création d'un nouveau Projet",
            submitButton: "Créer",
            projectCanEditList: this.CanEditList,
            // confirmationDialogOpen: false,
        }
    },  
    computed: {
        // ...mapState("project", ["selectedProject", "canEditList", "projectData", 'productionReferentials']),
        ...mapState("project", [ "selectedProject","canEditList", "projectData", 'productionReferentials', "loading"]),
        ...mapGetters("project", ["filterActiveProject", "readOnlyProject", "isEvaluationView"]),
        // ...mapState("referential", ["canEditList"]),
        /* ...mapGetters("referential", ["getReferentialStatus"]), */
        ...mapState("referential", [/* "canEditList", */ "selectedReferential","referentialData", "selectedReferential"]),

        isLocked() {
            if(this.selectedReferential === 0) {
                return this.selectedProject === 0
            } else {
                return false
            }
        },
    },
    watch: {
        selectedProject: {
            handler() {
                this.initializeForm();
            },
            immediate: true
        }
    },
    mounted() {
        if (this.productionReferentials.length === 0) {
            this.$store.dispatch("project/fetchProductionReferentials");
            /* this.$store.dispatch("project/getProjectRights"); */
        }
        document.body.classList.add('modal-open');
    },
    beforeUnmount() {
      document.body.classList.remove('modal-open');
    },
    methods: {
        initializeForm() {
            if (this.selectedProject > 0) {
                //OBJECT (right way !)
                const project = this.filterActiveProject;
                if (project) {
                    this.title = project.title;
                    this.description = project.description;
                    this.referential_id = project.referential_id;
                    this.releaseStatus = project.status;
                    this.modalHeader = "Éditer un Projet";
                    this.submitButton = "OK";
                } else {
                    console.error("Projet non trouvé pour l'initialisation du formulaire");
                }
            } else {
                this.title = "";
                this.description = "";
                this.referential_id = this.selectedReferential || 0;
                this.releaseStatus = "EDITING";
                this.modalHeader = "Création d'un nouveau Projet";
                this.submitButton = "Créer";
            }
        },
        getMaxLength() {
            return 100
            // return this.$store.getters["project/getMaxLength"]
        },
        closeModal() {
            this.$emit('close');
            if (this.selectedReferential === 0) {
                this.$store.commit("project/toggleProjectModalNew", false);
            } else {
                this.$store.commit("referential/toggleProjectCreatorModal", false);
            }
        },
        async submitForm() {
            if(this.releaseStatus != 'EDITING'){
                alert("Vous ne pouvez pas modifier les informations du projet");
                return;
            }
            if (!this.title || !this.description) {
                alert("Le titre et la description ne peuvent pas être vides.");
                return;
            }
            try {
                if (this.selectedProject > 0) {
                    await this.$store.dispatch("project/projectUpdate", {
                        project_id: this.selectedProject,
                        title: this.title,
                        description: this.description,
                    });
                } else if(this.referential_id === 0){
                    alert("Veuillez sélectionner un référentiel pour créer un projet");
                }else {
                    await this.$store.dispatch("project/projectInsert", {
                        title: this.title,
                        description: this.description,
                        referential_id: this.referential_id,
                        status: "EDITING",
                    });
                }
                this.closeModal();
            } catch (error) {
                console.error("La sauvegarde a échoué ", error);
                alert("Une erreur est survenue lors de la sauvegarde.");
            }
        },
        changeProjectStatus(status) {
            let title = ""
            let message = ""
            switch(status) {
                case "VALIDATION":
                    title = "Mise en évaluation"
                    message = "Êtes-vous sûr de vouloir mettre ce projet en évaluation ?<br>L'envoi du rapport pour évaluation vaut pour engagement au respect des informations fournies.<br>Une fois la demande d'évaluation effectuée ces dernières ne pourront plus être modifiées.<br>Merci de suivre l'évolution de la démarche dans l'onglet 'Suivi de l'évaluation'.<br>Un rapport d'évaluation ainsi qu'une notification vous parviendra une fois l'évaluation finalisée"
                    break;
                case "VALIDATED":
                    title = "Valider Projet"
                    message = "Êtes-vous sûr de vouloir valider ce projet ?"
                    break;
                case "ARCHIVE":
                    title = "Archiver"
                    message = "Êtes-vous sûr de vouloir archiver ce projet ?"
                    break;
                default:
                    title = "Remise en édition"
                    message = "Êtes-vous sûr de vouloir remettre ce projet en édition ?"
                    break;
            }
            this.$store.commit("project/returnConfirmationObjectMutation", { 
                id: this.selectedProject, 
                type: "project-change-status",
                title: title,
                message: message,
                newStatus: status,
                status: this.releaseStatus,
            })
            //console.log(`Demande de changement de statut de '${this.releaseStatus}' vers '${status}'`);
            this.closeModal();
        },
        getReferentialName() {
            //console.log("Getting referential name for ID:", this.projectData.find(p => p.project_id === this.selectedProject))
            var referentialName = this.projectData.find(p => p.project_id === this.selectedProject)?.referential_name
            if(referentialName) {
                return referentialName
            }
            return "Aucun référentiel sélectionné"
            // if(this.referentialData === null || this.referentialData.length === 0) {
            //     console.warn("No referential data available");
            //     this.$store.dispatch("referential/fetchReferentialList");
            // }
            // const referential = this.referentialData.find(r => r.referentiel_id === this.referential_id)
            // if(!referential) {
            //     //console.log("this is the referentialData ? : ", this.referentialData)
            //     return "Aucun référentiel sélectionné";
            // }
            // if(referential === 0){
            //     //console.log("this is an empty referential. Therefore you're redirected")
            // }
            // return referential ? referential.title : "Aucun référentiel sélectionné";
        },
    },
    
};
</script>

<style scoped>

</style>